// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1j-u6","detailsBorder":"styles_detailsBorder__XsArz"};